module.exports = __webpack_public_path__ + "static/media/pilotly-logo-white.06d93e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/pilotly-logo-white.png
// module id = 75
// module chunks = 0